// extracted by mini-css-extract-plugin
export default {"messageSender":"MessageSender_messageSender__Jhfu+","messageSenderIconSending":"MessageSender_messageSenderIconSending__RBblu"};